import classes from "./OverviewBox.module.css";
import { useDropdown } from "../../hooks/useDropdown";

export const OverviewBox = ({ creative, creativeImage }) => {
    const { isOpen: showDropdown, toggle: toggleDropdown, triggerRef, dropdownRef } = useDropdown();

    return (
        <div className={classes.overviewBox}>
            <header className={classes.creativeHeader}>
                <div className={classes.creativeImageWrapper}>
                    <div className={classes.creativeImageContainer}>
                        <img src={creative?.processedProfilePicture || creativeImage} alt="creative" />
                    </div>
                    <div className={classes.checkBoxContainer}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                            <path d="M12.3326 0C5.52145 0 0 5.52145 0 12.3326C0 19.1438 5.52145 24.6653 12.3326 24.6653C19.1438 24.6653 24.6653 19.1438 24.6653 12.3326C24.6653 5.52145 19.1438 0 12.3326 0ZM18.6857 10.0801C17.7491 11.1835 16.7874 12.2655 15.835 13.3558C14.9121 14.4131 13.9881 15.4698 13.063 16.5255C12.9423 16.6635 12.8196 16.7994 12.69 16.929C12.0907 17.5272 11.1909 17.609 10.5219 17.0838C9.12249 15.9851 7.72888 14.8785 6.35416 13.7493C5.45534 13.0111 5.4375 11.8819 6.27021 11.141C6.56561 10.8776 6.91717 10.7748 7.32224 10.7858C7.7782 10.7664 8.17331 10.9521 8.53063 11.2381C9.31401 11.8646 10.0969 12.4921 10.8808 13.1171C11.2103 13.3799 11.4113 13.359 11.6862 13.0447C13.0929 11.437 14.4986 9.82875 15.908 8.22315C16.0969 8.00698 16.2826 7.78345 16.5339 7.63339C17.2407 7.21152 18.0954 7.36159 18.6627 8.00593C19.1622 8.57261 19.1931 9.48192 18.6857 10.0801Z" fill="#DF315A"/>
                        </svg>
                    </div>
                </div>
                <div className={classes.headerTextContainer}>
                    <h3 className="titleSemibold2">{creative?.displayName}</h3>
                    <span className="regularMiddle" style={{ color: 'var(--dark-grey-4)' }}>
                        {creative?.jobTitle}
                    </span>
                </div>
            </header>
            <div className={classes.horizontalLine}></div>
            <div className={classes.servicesContainer}>
                <h3 className="regularSmall">Skills & Services</h3>
                <div className={classes.servicesContent}>
                    {creative?.skills?.slice(0, 4).map((skill, index) => (
                        <div className={classes.serviceItem} key={index}>
                            <span className="regularMiddle">{skill}</span>
                        </div>
                    ))}
                    {creative?.skills?.length > 4 && (
                    <button ref={triggerRef} onClick={toggleDropdown} className={`${classes.allViewButton} mediumLarge`}>+{creative?.skills?.length - 4}</button>
                    )}
                    {showDropdown && (
                        <div ref={dropdownRef} className={classes.dropdownContainer}>
                            {creative?.skills?.slice(4).map((skill, index) => (
                                <div className={classes.serviceItem} key={index}>
                                    <span className="regularMiddle">{skill}</span>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default OverviewBox;